import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {logout} from '../auth/redux/actions';
import {connect} from 'react-redux';
import settings from '../../../config/settings';

export class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: ''
    };

    this.logout = this.logout.bind(this);
  }

  componentWillMount() {
    this.setState({searchText: this.props.searchText});
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.searchText !== nextProps.searchText) {
      this.setState({searchText: nextProps.searchText});
    }
  }

  render() {
    const {props} = this;
    let profileText = '';
    const profile = _.get(props, 'profile');

    if (profile) {
      profileText = profile.name ? profile.name : profile.email;
    }

    const isLoggedIn = !!_.get(props, 'auth.token');

    return (
      <header className="ba-site-header">
        <div className="row small-collapse padding-1x">
          <div className="small-6 medium-2 large-2 columns">
            <Link to="/"
                  onClick={() => this.props.onHomeClick()}
                  title={_.get(settings, 'website.title')}
                  className="ba-site-header-home">
              RewardsMD
            </Link>
          </div>

          <div className="small-6 medium-2 medium-push-8 large-2 large-push-8 columns text-right">
            <div>
              {isLoggedIn ? <Link onClick={this.logout} className="right" style={{paddingTop: '10px'}}>Log out</Link> : <Link to="/login" className="right">Log in</Link>}

              {
                profile ?
                  <Link to="/profile" title={`profile: ${profileText}`} className="right" style={{marginRight: '10px'}}>
                    <i className="fa fa-user" style={{fontSize: '36px'}} /> </Link>
                  : null
              }
            </div>
          </div>
          <div className="small-12 medium-8 medium-pull-2 large-8 large-pull-2 columns ba-site-header-navigation" />
        </div>
      </header>
    );
  }

  logout() {
    this.props.dispatch(logout());
  }

  onSearch(keyEvent) {
    const key = keyEvent.which || keyEvent.keyCode;

    if (key === 13) {
      const {searchText} = this.state;

      const query = {q: searchText};
      this.context.router.push({pathname: '/', query});
    }
  }
}

Header.displayName = 'Header';
Header.propTypes = {
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object,
  onHomeClick: PropTypes.func.isRequired
};
Header.contextTypes = {
  router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {searchText: _.get(state, 'home.query.q', '')};
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./shared/common/Header.jsx